import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { OptionType } from '@evinced-private/ui-common';

import { getMobileSdkFilterOptions } from 'src/apps/mobile-sdk/services/MobileSdkDashboardService';
import { MOBILE_SDK_TESTS_FILTER_OPTIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export interface IMobileSdkFilterOptions {
	sdkType: OptionType[];
	sdkVersion: OptionType[];
	appName: OptionType[];
	appVersion: OptionType[];
}

export const useMobileSdkFilterOptionsQuery = (): UseQueryResult<IMobileSdkFilterOptions> => {
	return useQuery([MOBILE_SDK_TESTS_FILTER_OPTIONS], () => getMobileSdkFilterOptions());
};
